<template>
  <div class="result">
    <div class="result_nav">
      <navbar
        title="汽车租赁"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <img src="../../assets/carRent/car_rent_baner_detail.jpg" />
    </div>
  </div>
</template>
<script>
import navbar from "../purchaseSupplier/components/nav-bar.vue";
export default {
  components: {
    navbar,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
    };
  },
  created() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.result {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .result_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    padding: 10.3rem 1.6rem 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    img {
      width: 100%;
    }
  }
}
</style>